<span>
  Der Artikel
  <span class="article-name">
    {{ data.articleName | stripHTML | stripQuotes }}
  </span>
  wurde dem Warenkorb
  <span class="cost-center"> {{ data.number }} {{ data.costCenterName }} </span>
  hinzugefügt.
</span>
